"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Radio;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _excluded = ["style", "selected", "onPress"];
function Radio(props) {
  var style = props.style,
    selected = props.selected,
    onPress = props.onPress,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var outerStyle = {
    borderColor: selected ? _styles.colors.feature : _styles.colors.common
  };
  var innerStyle = {
    backgroundColor: selected ? _styles.colors.feature : _styles.colors.common,
    opacity: selected ? 1 : 0
  };
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: styles.container,
    disabled: !onPress,
    onPress: onPress
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.outer, outerStyle, style]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.inner, innerStyle]
  })));
}
Radio.propTypes = {
  selected: _propTypes["default"].bool,
  onPress: _propTypes["default"].func,
  label: _propTypes["default"].string,
  style: _propTypes["default"].any
};
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row'
  },
  outer: {
    height: 24,
    width: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: _styles.colors.common,
    alignItems: 'center',
    justifyContent: 'center'
  },
  inner: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: _styles.colors.common
  }
});